import { createTheme } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface Theme {
    customHeader: {
      backgroundImage: string;
      backgroundSize: string;
      backgroundPosition: string;
      backgroundRepeat: string;
      overflow: string;
      buttonBgColor: string;
      buttonHoverBgColor: string;
    };
  }
  interface ThemeOptions {
    customHeader?: {
      backgroundImage?: string;
      backgroundSize?: string;
      backgroundPosition?: string;
      backgroundRepeat?: string;
      overflow?: string;
      buttonBgColor?: string;
      buttonHoverBgColor?: string;
    };
  }
}

export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#4ECDC4',
    },
    secondary: {
      main: '#3dbdb5',
    },
    background: {
      default: '#0f1117',
      paper: '#1a1d24',
    },
    text: {
      primary: '#ffffff',
      secondary: '#6b7280',
    },
    divider: 'rgba(78, 205, 196, 0.15)',
  },
  customHeader: {
    backgroundImage: 'none',
    backgroundSize: 'auto',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    overflow: 'visible',
    buttonBgColor: 'transparent',
    buttonHoverBgColor: 'transparent',
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      'Segoe UI',
      'Roboto',
      'Helvetica Neue',
      'Arial',
      'sans-serif',
    ].join(','),
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 10,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#1a1d24',
          color: '#ffffff',
          boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: '#232830',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(255,255,255,0.02)',
          borderRadius: 8,
        },
      },
    },
  },
});